define('sentient/aba/collections/ProjectsCollectionProxy',[
	'jquery',
	'underscore',
	'backbone',
	'../models/ExerciseModelProxy'
	], function($, _, Backbone, ExerciseModelProxy) {
		var ProjectsCollectionProxy = Backbone.Collection.extend({
			model: ExerciseModelProxy,
			initialize: function() {}
		});
		return ProjectsCollectionProxy;
	});

